<template lang="pug">
  .list-item-delete
    v-dropdown
      slot
      .list-item-delete__btn(
        v-if="!isConsultant"
        slot="content"
        @click="$emit('remove')")
        v-icon(
          position-left
          font-size="1"
          :icon="['far', 'trash-alt']")
        span {{ 'base.delete' | translate }}
</template>

<script>
export default {
  name: 'ListItemDelete',

  props: {
    index: Number
  }
}
</script>

<style lang="scss">
.list-item-delete {

  &__btn {
    cursor: pointer;
    color: #fff;
    font-size: 1.5rem;
    text-transform: uppercase;
    height: 4rem;
    width: 100%;
    background-color: #FF6158;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);

    &:hover {
      background-color: darken(#FF6158, 3%);
    }

    span {
      padding-top: 2px;
    }
  }
}
</style>
